<shared-badge
  [class]="'badge badge-pill badge-light'"
  [label]="label"
  [tooltip]="tooltip"
></shared-badge>
